/**
 * @author @thkruz Theodore Kruczek
 * @license AGPL-3.0-or-later
 * @copyright (c) 2025 Kruczek Labs LLC
 *
 * Orbital Object ToolKit is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * Orbital Object ToolKit is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * Orbital Object ToolKit. If not, see <http://www.gnu.org/licenses/>.
 */
/**
 * Enum representing different types of objects.
 */
export var SpaceObjectType;
(function (SpaceObjectType) {
    SpaceObjectType[SpaceObjectType["UNKNOWN"] = 0] = "UNKNOWN";
    SpaceObjectType[SpaceObjectType["PAYLOAD"] = 1] = "PAYLOAD";
    SpaceObjectType[SpaceObjectType["ROCKET_BODY"] = 2] = "ROCKET_BODY";
    SpaceObjectType[SpaceObjectType["DEBRIS"] = 3] = "DEBRIS";
    SpaceObjectType[SpaceObjectType["SPECIAL"] = 4] = "SPECIAL";
    SpaceObjectType[SpaceObjectType["BALLISTIC_MISSILE"] = 8] = "BALLISTIC_MISSILE";
    SpaceObjectType[SpaceObjectType["STAR"] = 9] = "STAR";
    SpaceObjectType[SpaceObjectType["INTERGOVERNMENTAL_ORGANIZATION"] = 10] = "INTERGOVERNMENTAL_ORGANIZATION";
    SpaceObjectType[SpaceObjectType["SUBORBITAL_PAYLOAD_OPERATOR"] = 11] = "SUBORBITAL_PAYLOAD_OPERATOR";
    SpaceObjectType[SpaceObjectType["PAYLOAD_OWNER"] = 12] = "PAYLOAD_OWNER";
    SpaceObjectType[SpaceObjectType["METEOROLOGICAL_ROCKET_LAUNCH_AGENCY_OR_MANUFACTURER"] = 13] = "METEOROLOGICAL_ROCKET_LAUNCH_AGENCY_OR_MANUFACTURER";
    SpaceObjectType[SpaceObjectType["PAYLOAD_MANUFACTURER"] = 14] = "PAYLOAD_MANUFACTURER";
    SpaceObjectType[SpaceObjectType["LAUNCH_AGENCY"] = 15] = "LAUNCH_AGENCY";
    SpaceObjectType[SpaceObjectType["LAUNCH_SITE"] = 16] = "LAUNCH_SITE";
    SpaceObjectType[SpaceObjectType["LAUNCH_POSITION"] = 17] = "LAUNCH_POSITION";
    SpaceObjectType[SpaceObjectType["LAUNCH_FACILITY"] = 18] = "LAUNCH_FACILITY";
    SpaceObjectType[SpaceObjectType["CONTROL_FACILITY"] = 19] = "CONTROL_FACILITY";
    SpaceObjectType[SpaceObjectType["GROUND_SENSOR_STATION"] = 20] = "GROUND_SENSOR_STATION";
    SpaceObjectType[SpaceObjectType["OPTICAL"] = 21] = "OPTICAL";
    SpaceObjectType[SpaceObjectType["MECHANICAL"] = 22] = "MECHANICAL";
    SpaceObjectType[SpaceObjectType["PHASED_ARRAY_RADAR"] = 23] = "PHASED_ARRAY_RADAR";
    SpaceObjectType[SpaceObjectType["OBSERVER"] = 24] = "OBSERVER";
    SpaceObjectType[SpaceObjectType["BISTATIC_RADIO_TELESCOPE"] = 25] = "BISTATIC_RADIO_TELESCOPE";
    SpaceObjectType[SpaceObjectType["COUNTRY"] = 26] = "COUNTRY";
    SpaceObjectType[SpaceObjectType["LAUNCH_VEHICLE_MANUFACTURER"] = 27] = "LAUNCH_VEHICLE_MANUFACTURER";
    SpaceObjectType[SpaceObjectType["ENGINE_MANUFACTURER"] = 28] = "ENGINE_MANUFACTURER";
    SpaceObjectType[SpaceObjectType["NOTIONAL"] = 29] = "NOTIONAL";
    SpaceObjectType[SpaceObjectType["FRAGMENT"] = 30] = "FRAGMENT";
    SpaceObjectType[SpaceObjectType["SHORT_TERM_FENCE"] = 31] = "SHORT_TERM_FENCE";
    SpaceObjectType[SpaceObjectType["TERRESTRIAL_PLANET"] = 33] = "TERRESTRIAL_PLANET";
    SpaceObjectType[SpaceObjectType["GAS_GIANT"] = 34] = "GAS_GIANT";
    SpaceObjectType[SpaceObjectType["ICE_GIANT"] = 35] = "ICE_GIANT";
    SpaceObjectType[SpaceObjectType["DWARF_PLANET"] = 36] = "DWARF_PLANET";
    SpaceObjectType[SpaceObjectType["MOON"] = 37] = "MOON";
    SpaceObjectType[SpaceObjectType["MAX_SPACE_OBJECT_TYPE"] = 40] = "MAX_SPACE_OBJECT_TYPE";
})(SpaceObjectType || (SpaceObjectType = {}));
export var ZoomValue;
(function (ZoomValue) {
    ZoomValue[ZoomValue["LEO"] = 0.45] = "LEO";
    ZoomValue[ZoomValue["GEO"] = 0.82] = "GEO";
    ZoomValue[ZoomValue["MAX"] = 1] = "MAX";
})(ZoomValue || (ZoomValue = {}));
/*
 * + Operational
 * - Nonoperational
 * P Partially Operational
 * Partially fulfilling primary mission or secondary mission(s)
 * B Backup/Standby
 * Previously operational satellite put into reserve status
 * S Spare
 * New satellite awaiting full activation
 * X Extended Mission
 * D Decayed
 * ? Unknown
 */
export var PayloadStatus;
(function (PayloadStatus) {
    PayloadStatus["OPERATIONAL"] = "+";
    PayloadStatus["NONOPERATIONAL"] = "-";
    PayloadStatus["PARTIALLY_OPERATIONAL"] = "P";
    PayloadStatus["BACKUP_STANDBY"] = "B";
    PayloadStatus["SPARE"] = "S";
    PayloadStatus["EXTENDED_MISSION"] = "X";
    PayloadStatus["DECAYED"] = "D";
    PayloadStatus["UNKNOWN"] = "?";
})(PayloadStatus || (PayloadStatus = {}));
